import BaseListPresenter from "../../../base/BaseListPresenter";

class SearchLogsListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  async createQuery() {
    const currentUser = this.view.getCurrentUser();

    const where = {
      searcher: { affiliate: { id: currentUser.affiliate.id } },
      searcher: { branch: { id: currentUser.branch.id } },
    };

    const skip = (this.current - 1) * this.limit;
    const keysRendered = [
      "createdAt",
      "searched_alias",
      "searched_first_name",
      "searched_last_name",
      "searched_middle_name",
      "searched_company",
      "searcher",
      "searcher.firstName",
      "searcher.middleName",
      "searcher.lastName",
    ];
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
        ...where,
      },
      include: this.include,
      keys: keysRendered,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async countObjects() {
    const currentUser = this.view.getCurrentUser();
    const where = {
      searcher: { affiliate: { id: currentUser.affiliate.id } },
    };

    try {
      const collection = this.view.getCollectionName();
      const objects = await this.findObjectUseCase.execute(collection, {
        where,
      });

      this.count = objects.length;
      this.view.setCount(this.count);
    } catch (error) {
      this.view.showError(error);
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const currentUser = this.view.getCurrentUser();
    const query = await this.createQuery();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      // GET CREDIT DETAILS
      const [credit] = await this.findObjectUseCase.execute("credits", {
        where: { client: { id: currentUser.affiliate.id } },
      });

      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.view.setCredit(credit);
    } catch (error) {
      this.view.showError(error);
    }
    this.progress = false;
  }
}

export default SearchLogsListPresenter;
